export const environment = {
    isProduction: false,
    baseUrl: 'https://bcndata.ap.iquadrat.com',
    launcherUrl: 'https://bcndata-apps.iquadrat.com'
};
